import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { convertLitersToBbl, convertLitersToGll } from "../functions/uom-conversion.functions";
import { Uom } from "../model/uom";

@Injectable({ providedIn: 'root' })
export class UomService {
    constructor() { }

    private currentUom$ = new BehaviorSubject<Uom>('L');
    public current$ = this.currentUom$.asObservable();

    private get uom(): Uom {
        return this.currentUom$.value;
    }

    valueFromLiters(value: number): number {
        if(value === null) return value;
        return this.uom === 'Bbl'
            ? convertLitersToBbl(value)
                : this.uom === 'Gll'
                    ? convertLitersToGll(value) : value;
    }

    changeUom(uom: Uom) {
        this.currentUom$.next(uom);
    }
}